@if (isVisible()) {
  <div
    class="search-launcher-backdrop"
    [class.search-launcher-backdrop--closing]="isClosing()"
    role="dialog"
    aria-modal="true"
    aria-label="Búsqueda global"
    (click)="close()">
    <div
      class="search-launcher-shell"
      [class.search-launcher-shell--closing]="isClosing()"
      [class.chrome-dark]="themeService.isDark()"
      [class.chrome-light]="themeService.isLight()"
      (click)="$event.stopPropagation()">
      <div class="search-launcher-panel">
        <p-inputgroup class="search-launcher-input">
          <p-inputgroup-addon>
            <mat-icon class="search-launcher-input__icon">search</mat-icon>
          </p-inputgroup-addon>

          <div class="search-launcher-input-wrap">
            <input
              #launcherInput
              pInputText
              type="search"
              class="search-launcher-input__field"
              placeholder=" "
              [attr.aria-label]="shortcuts.searchLauncherAriaLabel()"
              autocomplete="off"
              spellcheck="false"
              [ngModel]="search.term()"
              (ngModelChange)="onTermChange($event)"
              (keydown)="onInputKeydown($event)" />

            @if (showSearchShortcutHint()) {
            <app-search-shortcut-hint class="search-launcher-shortcut-hint" [overlay]="true" />
            }
          </div>

          <p-inputgroup-addon class="navbar-search-scope-addon">
            <button
              type="button"
              class="navbar-search-scope-label search-launcher-scope-label"
              aria-haspopup="menu"
              aria-label="Tipo de búsqueda"
              (click)="openSearchScopeMenu($event)">
              <i [class]="search.scopeIcon()" aria-hidden="true"></i>
              <span>{{ search.scopeLabel() }}</span>
            </button>
            <p-contextmenu
              #searchScopeMenu
              [model]="search.scopeMenuItems()"
              appendTo="body"
              styleClass="navbar-search-scope-menu"
              ariaLabel="Tipo de búsqueda" />
          </p-inputgroup-addon>
        </p-inputgroup>

        <div class="search-launcher-body">
          @if (search.loading()) {
          <div class="search-launcher-status">
            <span class="search-launcher-spinner" aria-hidden="true"></span>
            <span>Buscando…</span>
          </div>
          } @else if (queryLength() >= 3 && search.suggestions().length === 0) {
          <div class="search-launcher-status">Sin resultados para «{{ queryLabel() }}»</div>
          } @else if (queryLength() > 0 && queryLength() < 3) {
          <div class="search-launcher-status">Escribe al menos 3 caracteres</div>
          } @else if (search.suggestions().length > 0) {
          <ul class="search-launcher-results" role="listbox" aria-label="Resultados de búsqueda">
            @for (item of search.suggestions(); track item.entityType + ':' + item.entityId; let i = $index) {
            <li>
              <button
                type="button"
                class="search-launcher-result"
                [class.search-launcher-result--active]="i === activeIndex()"
                role="option"
                [attr.aria-selected]="i === activeIndex()"
                (click)="selectItem(item)">
                <span class="search-hit__icon" aria-hidden="true">
                  <i [class]="search.navIconClass(item.icon, item.entityType)" aria-hidden="true"></i>
                </span>
                <span class="search-hit__body">
                  <span class="search-hit__title">{{ item.title }}</span>
                  @if (item.description?.trim()) {
                  <span class="search-hit__desc">{{ item.description }}</span>
                  }
                </span>
              </button>
            </li>
            }
          </ul>
          } @else {
          <div class="search-launcher-status search-launcher-status--hint">
            Busca clientes, productos, ventas, suscripciones y más
          </div>
          }
        </div>

        <footer class="search-launcher-footer">
          <span class="search-shortcut-hint__keys">
            <kbd class="search-shortcut-kbd">{{ shortcuts.searchLauncherModifierLabel() }}</kbd>
            <kbd class="search-shortcut-kbd search-shortcut-kbd--glyph">+</kbd>
            <kbd class="search-shortcut-kbd">Espacio</kbd>
          </span>
          <span>abrir</span>
          <span><kbd>↑</kbd> <kbd>↓</kbd> navegar</span>
          <span><kbd>Enter</kbd> ir</span>
          <span><kbd>Esc</kbd> cerrar</span>
        </footer>
      </div>
    </div>
  </div>
}
